define('cartware_checkout/components/advises/login',[
	"jquery",
	"cartware/components/_base",
	"cartware_checkout"
], function(
	$,
	Component,
	CartwareCheckout
) {
	return Component.create({
		init: function() {
			var _setMethod = Checkout.prototype.setMethod;

			Checkout.prototype.setMethod = function(method) {
				// var allowedMethods = ['guest', 'register'];
				// if (!$.inArray) {
				// 	alert(Translator.translate('Please choose to register or to checkout as a guest').stripTags());
				// 	return false;
				// }
				this.method = method;
				new Ajax.Request(
					this.saveMethodUrl,
					{
						method: 'post',
						parameters: {method: method},
						onFailure: this.ajaxFailure.bind(this),
						onSuccess: function (transport) {
							var response = transport.responseJSON || transport.responseText.evalJSON(true) || {};

							if (response.blocks && ('register' in response.blocks)) {
								$('#customer-account-registration').replaceWith(response.blocks['register']);
							}

							if (response.error){
								if ((typeof response.message) == 'string') {
									alert(response.message);
								} else {
									alert(response.message.join("\n"));
								}

								return false;
							}

							this.gotoSection('shipping', true);
						}.bind(this),
						onComplete: function () {
							this.setLoadWaiting(false);
						}.bind(this),
					}
				);

				checkout.setLoadWaiting('shipping');

				document.body.fire('login:setMethod', {method : this.method});
			};
		}
	});
});
